import React, { useState, useRef, useEffect } from 'react'
import { useCheckedState } from '../../../../shared/contexts/CheckedContext'
import config from '../../../../config/config'

// Function based component that renders a clear all label
function ClearAll({ data }) {
  const { checkedState, setCheckedState } = useCheckedState()
  
  // State to manage the confirmation mode
  const [isConfirming, setIsConfirming] = useState(false);
  // Ref to hold the timer ID for cleanup and to prevent re-renders
  const timerRef = useRef(null);

  // The core logic to remove all selected data points
  const performDeletion = () => {
    let updatedCheckedState = JSON.parse(JSON.stringify(checkedState))
    for (let element of data) {
      updatedCheckedState[element[config.data.primary_key]] = false
    }
    setCheckedState(updatedCheckedState)
  }

  // New combined click handler to manage the two-step confirmation
  const handleClick = () => {
    if (isConfirming) {
      // 2. CONFIRMATION CLICK: Proceed with deletion
      performDeletion();
      
      // Reset state and clear timer
      setIsConfirming(false);
      clearTimeout(timerRef.current);
      timerRef.current = null;
    } else {
      // 1. INITIAL CLICK: Enter confirmation mode
      
      // Set to confirming state
      setIsConfirming(true);
      
      // Clear any existing timer just in case
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      // Start the 3-second timer to automatically revert the button text
      timerRef.current = setTimeout(() => {
        // 3. TIMEOUT: Revert back to normal state
        setIsConfirming(false);
        timerRef.current = null;
      }, 5000); // 3 seconds
    }
  }

  // Cleanup effect: clear the timer when the component unmounts
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);
  
  // Determine button content based on state
  const buttonText = isConfirming ? "Click again to confirm" : "Clear Selection";
  // Optionally change the icon to indicate a warning/confirmation state
  const buttonIconClass = isConfirming ? "bx bxs-error-circle med-button-image" : "bx bxs-trash med-button-image";


  return (
    <button
      className="med-primary-solid med-bx-button med-data-button"
      onClick={handleClick}
      data-testid="clear-all-label"
    >
      <i className={buttonIconClass}></i>{buttonText}
    </button>
  )
}

export default ClearAll